<script setup lang="ts">
import type { TimelineItem } from '~/components/Logistics/computeStatus'

defineProps<{ timelineItems?: TimelineItem[] }>()
</script>

<template>
  <n-timeline>
    <n-timeline-item
      v-for="timeline of timelineItems"
      :key="timeline.title"
      :title="timeline.title"
      :time="timeline.time"
      :type="timeline.statusState"
      :content="timeline.content ?? undefined"
      style="max-width: 180px;"
    >
      <template v-if="timeline.statusState === 'success'" #icon>
        <Icon name="material-symbols:check-circle" />
      </template>
    </n-timeline-item>
  </n-timeline>
</template>
